import React from 'react';
import { Image } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';

class View extends React.Component {

  state = {
    file: '',
  }

  componentDidMount() {
    this.setState({
      file: this.props.image,
    });
  }

  handleFile = e => {
    if (!this.props.menuPermission.edit) {
      alert('Access is Denied!!!');
      return;
    }
    this.updateLocalfile(e.target.files[0]);
    this.updateImage(e.target.files[0]);
  }

  updateLocalfile(value) {
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({
        file: out
      });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  updateImage(file) {
    let context = this;
    var formData = new FormData();
    formData.append('id', this.props.id);
    formData.append('file', file);
    $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'offer/imageupdate.php',
      success: function(data)
      {
        console.log(data);
        if (data == 1) {

        }
        else {
          alert('Image not upload successfull...Try again!!!!')
        }
      },
      error: function(error)
      {
        alert('Try again!!!');
        console.log(error);
      }
    });
  }

  render() {
    return (
      <div>
        <input id={this.props.id} type="file" onChange={this.handleFile} style={{display: 'none'}}/>
        <label htmlFor={this.props.id}>
          <Image src={this.state.file} size='small'
          style={{width: 80, height: 50, cursor: 'pointer'}}
          id='image' />
        </label>
      </div>
    );
  }
}

export default View;
